"use client";

import {
  PointerSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
} from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import type { RowData, Table } from "@tanstack/react-table";
import type { RecordGridFeatures } from "./record-grid-features";
import type { RecordTableState } from "../types";

export function useColumnReorder<TData extends RowData>(
  state: RecordTableState,
  table: Table<RecordGridFeatures, TData>,
) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  );

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (!over || active.id === over.id) return;
    const order =
      state.columns.order.length > 0
        ? [...state.columns.order]
        : table.getAllLeafColumns().map((column) => column.id);
    const from = order.indexOf(String(active.id));
    const to = order.indexOf(String(over.id));
    if (from === -1 || to === -1) return;
    state.setColumns({ ...state.columns, order: arrayMove(order, from, to) });
  };

  return { sensors, handleDragEnd };
}
